import type { FC, PropsWithChildren } from 'react';

import type { Permission } from 'api/types';
import { hasRequiredPermission } from 'shared/lib/auth/hasRequiredPermission';
import { useAuth } from 'shared/lib/auth/useAuth';
import { NoPermissionAtAllView } from 'views/errors/NoPermissionAtAllView';
import { NoPermissionView } from 'views/errors/NotPermissionView';

type AuthGuardProps = PropsWithChildren<{
  permission?: Permission | Permission[];
}>;

export const PermissionGuard: FC<AuthGuardProps> = ({ children, permission }) => {
  const { permissions } = useAuth();

  if (permissions.size === 0) {
    return <NoPermissionAtAllView />;
  }

  if (!hasRequiredPermission({ userPermissions: permissions, requiredPermissions: permission })) {
    return <NoPermissionView />;
  }

  return <>{children}</>;
};
